import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './Dashboard';
import Login from './login';
import SubcategoryForm from './SubcategoryForm'; // ✅ Add this line
import CategoryForm from './CategoryForm';
import ProductForm from './AddProductForm';
import AddProductForm from './AddProductForm';
import EditProduct from './EditProduct'; // ✅ Add this line
import OrderDetails from './OrderDetails'; // ✅ Add this line
import ProductUpload from './ProductUpload'; // ✅ correct path


// import AddProductForm from './AddProductForm'; // ✅ Add this line 
// import AddProductPage from './AddProductPage'; // ✅ Add this line
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/add-category" element={<CategoryForm />} />
        <Route path="/add-subcategory" element={<SubcategoryForm />} /> {/* ✅ Add this line */}
         <Route path="/add-product" element={<ProductForm />} /> {/* 👈 Add this line */}
        <Route path="/edit-category/:id" element={<CategoryForm />} />
        <Route path="/add-subcategory" element={<SubcategoryForm />} />
        <Route path="/edit-subcategory/:id" element={<SubcategoryForm />} />
        <Route path="/add-product" element={<AddProductForm />} />
        <Route path="/edit-product/:id" element={<EditProduct />} />
        <Route path="/orders/:id" element={<OrderDetails />} />
        <Route path="/productupload" element={<ProductUpload />} />




      </Routes>
    </Router>
  );
}

export default App;
